export default {"src":"/_next/static/media/bathtub.0be50fe4.svg","height":100,"width":100};